import { useEffect, useState } from 'react';
import { Range, RangeKeyDict } from 'react-date-range';

import Calendar from '@components/calendar/Calendar';
import { PickerProps } from '@types';
import { formatISODate, getNumberOfDaysBetweenTwoDates } from '@utils/date';

const CustomPicker = ({
  handleDateRangeSelect,
  minDate,
  maxDate,
  defaultDateRange,
  minimumDateDifference = 1,
  maximumDateDifference,
  className,
  showSelectedDate = true,
  disabledDateData
}: PickerProps) => {
  const [selectedDate, setSelectedDates] = useState<Range>({
    startDate: defaultDateRange?.startDate || new Date(),
    endDate: defaultDateRange?.endDate || new Date(),
    key: 'selection'
  });

  const handleDateChange = (dateObject: RangeKeyDict) => {
    const { selection } = dateObject;
    setSelectedDates(selection);
  };

  const selectedDaysCount = getNumberOfDaysBetweenTwoDates(
    selectedDate?.startDate || new Date(),
    selectedDate?.endDate || new Date()
  );
  const showMinimumDateWarning = selectedDaysCount < minimumDateDifference;
  const showMaximumDateWarning =
    !!maximumDateDifference && selectedDaysCount > maximumDateDifference;

  useEffect(() => {
    if (selectedDate?.startDate && selectedDate?.endDate)
      handleDateRangeSelect({
        startDate: selectedDate.startDate,
        endDate: selectedDate.endDate
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  return (
    <div className={className || ''}>
      {showSelectedDate && (
        <div className="text-sm font-normal text-cofeeNeutral10">
          Start Date - End Date
        </div>
      )}
      <div className="relative mt-3 flex h-10 w-full items-center justify-between rounded-lg border border-cofeeGreyBlue4 bg-cofeeNeutral1 px-3 text-sm text-cofeeNeutral10">
        {showSelectedDate && (
          <div>
            {selectedDate
              ? `${formatISODate({
                  date: selectedDate.startDate || new Date(),
                  format: 'DD MMM YYYY'
                })} - ${formatISODate({
                  date: selectedDate.endDate || new Date(),
                  format: 'DD MMM YYYY'
                })}`
              : 'Select Date'}
          </div>
        )}
        {showMinimumDateWarning && (
          <div className="absolute top-8 text-xs text-error50">
            {`Minimum dates should be ${minimumDateDifference}`}
          </div>
        )}
        {showMaximumDateWarning && (
          <div className="absolute top-8 text-xs text-error50">
            {`Maximum range is ${maximumDateDifference} days`}
          </div>
        )}
      </div>
      <div className="mt-1">
        <Calendar
          handleChange={handleDateChange}
          startDate={selectedDate.startDate}
          endDate={selectedDate.endDate}
          maxDate={maxDate || new Date()}
          {...(!disabledDateData && { minDate })}
          disabledDateData={disabledDateData}
        />
      </div>
    </div>
  );
};

export default CustomPicker;
